export default __webpack_public_path__ + "static/media/logo-dark.3158aef5.svg";